import answerIcon from "src/Assets/images/answerIcon.png";

export default function AnswerSvg() {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <img src={answerIcon} alt="Answer" style={{margin: "0px 0px 0px 9px", height: "28px"}}/>
      <span
        style={{
          fontSize: "14px",
          color: "#373334",
          lineHeight: 1,
        }}
      >
        Answers
      </span>
    </span>
  );
}
